import { Link } from "react-router-dom";
import articles from "../data/articles.json";
import "../styles/recentnews.css";

const RecentNews = ({ limit = 5 }) => {
  const recentNews = [...articles]
    .sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      return dateB - dateA;
    })
    .slice(0, limit);

  return (
    <div className="recent-news pb-5">
      <h3 className="recent-news-title">
        Recent News
      </h3>

      {recentNews.length === 0 ? (
        <p>No news found.</p>
      ) : (
        <ul className="recent-news-list">
          {recentNews.map((news) => (
            <li
              key={news.id || news.slug}
              className="recent-news-item"
            >
              <Link
                to={`/news/${news.slug}`}
                className="recent-news-link"
              >
                {news.title}
              </Link>
            </li>
          ))}
        </ul>
      )}

      <div className="recent-news-footer">
        <Link
          to="/news"
          className="recent-news-view-all"
        >
          View All News →
        </Link>
      </div>
    </div>
  );
};

export default RecentNews;